import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, KeyRound, ShieldAlert } from "lucide-react";

const errMsg = (e, f) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : f;
};

export default function SetPassword() {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 10) return toast.error("Password must be at least 10 characters");
    if (pw !== pw2) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      const r = await api.post("/auth/first-password", { new_password: pw });
      localStorage.setItem("psc_token", r.data.token);
      localStorage.setItem("psc_user", JSON.stringify(r.data.user));
      toast.success("Password set — you're all set");
      window.location.href = "/";
    } catch (e2) { toast.error(errMsg(e2, "Could not set password")); }
    finally { setBusy(false); }
  };

  const signOut = () => {
    localStorage.removeItem("psc_token");
    localStorage.removeItem("psc_user");
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen bg-[#0F0E2E] flex items-center justify-center px-4" data-testid="set-password-page">
      <div className="w-full max-w-md bg-white border-2 border-slate-200 p-8">
        <div className="flex items-center gap-2 text-amber-600 mb-1">
          <ShieldAlert size={18} strokeWidth={2.5} />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Security · Required</span>
        </div>
        <h1 className="text-2xl font-black text-slate-900 mb-2">Create your permanent password</h1>
        <p className="text-sm text-slate-600 mb-5">
          You signed in with a temporary password. For your security, please set your own password to continue.
          Your temporary password will stop working once you do.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="block text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 mb-1">New password</span>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-pw"
              placeholder="Min 10 chars, upper, lower, number"
              className="h-11 w-full px-3 border-2 border-slate-300 focus:border-[#1E1B4B] focus:outline-none text-sm" />
          </label>
          <label className="block">
            <span className="block text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 mb-1">Confirm password</span>
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="set-pw2"
              className="h-11 w-full px-3 border-2 border-slate-300 focus:border-[#1E1B4B] focus:outline-none text-sm" />
          </label>
          <button type="submit" disabled={busy} data-testid="set-pw-submit"
            className="h-11 w-full inline-flex items-center justify-center gap-2 bg-[#1E1B4B] text-white font-bold text-sm uppercase tracking-wider hover:bg-[#0F0E2E] disabled:opacity-60">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <><KeyRound size={15} /> Set password & continue</>}
          </button>
        </form>
        <button onClick={signOut} className="mt-4 text-xs font-bold text-slate-500 hover:text-slate-800 underline">Sign out</button>
      </div>
    </div>
  );
}
